/**
 * React Query key factory for the jobs slice. Centralizing these prevents
 * key drift between the read hooks and the cache invalidations issued by
 * mutation hooks.
 *
 * The keys are scoped by JWT — when the user logs out, ProjectCacheCleaner
 * + IdentityCacheCleaner clear React Query state by `removeQueries({
 * queryKey: ["jobs"] })`. (See ProjectCacheCleaner / IdentityCacheCleaner
 * — the same pattern applies.)
 */

export const jobsQueryKey = {
    list: () => ["jobs", "list"] as const,
    job: (jobId: string) => ["jobs", "byId", jobId] as const,
    checklists: (projectId: string) => ["jobs", "checklists", projectId] as const,
};
